import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useWindowSize } from '../hooks/useWindowSize';
import { C, E, RAYON, T, champ as champStyle, bouton } from '../theme';
import axios from 'axios';
import Projets from './Projets';
import Assurance from './Assurance';
import Toast from '../components/Toast';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { API, urlFichier } from '../api';
import { IconeCorbeille, IconeCrayon } from '../components/Icones';


const INTERETS_CLIENT = ['RC', 'Mutuelle', 'Prévoyance', 'Assurance auto', 'Crédit', 'Autre'];

const TYPE_CONFIG = {
  prospect:  { color: '#f97316', label: 'Prospect' },
  client:    { color: '#059669', label: 'Client' },
  apporteur: { color: '#6366f1', label: 'Apporteur' },
};

const parseList = (str) => (str ? str.split(',').filter(Boolean) : []);
const serializeList = (arr) => arr.join(',');

const STATUT_PROJET_COLORS = {
  'En attente':    { bg: '#fef3c7', text: '#92400e' },
  'Gagné':         { bg: '#d1fae5', text: '#065f46' },
  'Accord envoyé': { bg: '#dbeafe', text: '#1e40af' },
  'Gagné facturé': { bg: '#cffafe', text: '#155e75' },
  'Perdu':         { bg: '#fee2e2', text: '#991b1b' },
};

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const GEOCODE_CACHE_KEY = 'crm_geocode_cache_v1';
// Encadré et titre de section, repris une dizaine de fois dans cette page.
// Au niveau du fichier : les composants auxiliaires définis plus bas
// (AffairesAmenes, MiniCarte) s'en servent aussi.
const carteSection = {
  background: C.surface, borderRadius: RAYON.lg, padding: E.lg,
  border: `1px solid ${C.bordure}`, marginBottom: E.lg,
};
const titreSection = { fontSize: '14px', fontWeight: 600, color: C.texte,
                       margin: `0 0 ${E.lg}` };

function loadCacheFiche() {
  try { return JSON.parse(localStorage.getItem(GEOCODE_CACHE_KEY) || '{}'); }
  catch { return {}; }
}
function saveCacheFiche(cache) {
  try { localStorage.setItem(GEOCODE_CACHE_KEY, JSON.stringify(cache)); }
  catch {}
}

function MiniCarte({ adresse }) {
  const [coords, setCoords] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!adresse || !adresse.trim()) { setLoading(false); return; }
    const key = adresse.trim().toLowerCase();
    const cache = loadCacheFiche();
    if (cache[key]) { setCoords(cache[key]); setLoading(false); return; }
    if (cache[key] === null) { setLoading(false); return; }
    fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(adresse)}&limit=1&countrycodes=fr`, {
      headers: { 'Accept-Language': 'fr', 'User-Agent': 'CRM-CB-Courtage/1.0' },
    })
      .then(r => r.json())
      .then(data => {
        const c = data.length > 0 ? { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) } : null;
        cache[key] = c;
        saveCacheFiche(cache);
        setCoords(c);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [adresse]);

  if (!adresse || !adresse.trim()) return null;
  const gmapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(adresse)}`;

  return (
    <div style={{ marginTop: '20px', gridColumn: '1 / -1' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <div style={{ fontSize: '12px', color: '#9ca3af', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Localisation</div>
        <a href={gmapsUrl} target="_blank" rel="noopener noreferrer"
          style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #e5e7eb', borderRadius: '6px', padding: '5px 12px', fontSize: '12px', fontWeight: '600', textDecoration: 'none' }}>Itinéraire
        </a>
      </div>
      {loading ? (
        <div style={{ height: '200px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af', fontSize: '13px' }}>
          Chargement de la carte…
        </div>
      ) : coords ? (
        <div style={{ height: '200px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e5e7eb' }}>
          <MapContainer center={[coords.lat, coords.lng]} zoom={15} style={{ height: '100%', width: '100%' }} zoomControl scrollWheelZoom={false}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={[coords.lat, coords.lng]} />
          </MapContainer>
        </div>
      ) : (
        <div style={{ height: '60px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af', fontSize: '13px' }}>
          Adresse non géolocalisable
        </div>
      )}
    </div>
  );
}

function AffairesAmenes({ apporteurId }) {
  const [affaires, setAffaires] = useState([]);
  const [prospects, setProspects] = useState([]);

  useEffect(() => {
    axios.get(`${API}/projets?apporteur_id=${apporteurId}`)
      .then(res => setAffaires(res.data))
      .catch(() => setAffaires([]));
    axios.get(`${API}/prospects`)
      .then(res => setProspects(res.data))
      .catch(() => setProspects([]));
  }, [apporteurId]);

  const formatMoney = (val) => {
    if (val === null || val === undefined || val === '') return '—';
    return Number(val).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €';
  };
  const formatDate = (d) => d ? new Date(d).toLocaleDateString('fr-FR') : '—';
  const getProspect = (id) => prospects.find(p => p.id === id);

  return (
    <div style={carteSection}>
      <h2 style={titreSection}>Affaires amenées <span style={{ color: '#9ca3af', fontSize: '13px', fontWeight: '400' }}>({affaires.length})</span>
      </h2>
      {affaires.length === 0 ? (
        <div style={{ color: '#9ca3af', fontSize: '14px', textAlign: 'center', padding: '20px 0' }}>
          Aucune affaire enregistrée pour cet apporteur
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e5e7eb' }}>
              {['Client', 'Statut projet', 'Produit', 'Financement', 'Montant', 'Commission nette', 'Échéance'].map(h => (
                <th key={h} style={{ padding: '10px 12px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {affaires.map(a => {
              const commNette = ((a.taux_commission || 0) / 100) * (a.prix_produit || 0) - (a.retribution_apporteur || 0);
              const prospect = getProspect(a.prospect_id);
              const statutProjet = a.statut_projet;
              const statutStyle = STATUT_PROJET_COLORS[statutProjet] || { bg: '#f3f4f6', text: '#6b7280' };
              return (
                <tr key={a.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <td style={{ padding: '12px 12px', fontSize: '13px', fontWeight: '500' }}>
                    {prospect ? (
                      <a href={`/prospects/${prospect.id}`} style={{ color: '#1a2b4a', textDecoration: 'none', fontWeight: '600' }}
                        onMouseEnter={e => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={e => e.target.style.textDecoration = 'none'}>
                        {prospect.nom_societe}
                      </a>
                    ) : '—'}
                  </td>
                  <td style={{ padding: '12px 12px' }}>
                    {statutProjet ? (
                      <span style={{ background: statutStyle.bg, color: statutStyle.text, padding: '3px 9px', borderRadius: '99px', fontSize: '11px', fontWeight: '600', whiteSpace: 'nowrap' }}>
                        {statutProjet}
                      </span>
                    ) : '—'}
                  </td>
                  <td style={{ padding: '12px 12px', fontSize: '13px', fontWeight: '500', color: '#1a2b4a' }}>{a.nom_produit || a.materiel || '—'}</td>
                  <td style={{ padding: '12px 12px', fontSize: '13px', color: '#374151' }}>{a.type_financement || '—'}</td>
                  <td style={{ padding: '12px 12px', fontSize: '13px', color: '#374151' }}>
                    {a.montant_financement ? formatMoney(a.montant_financement) : formatMoney(a.prix_produit ?? a.valeur_ht)}
                  </td>
                  <td style={{ padding: '12px 12px', fontSize: '13px', fontWeight: '600', color: a.taux_commission ? (commNette >= 0 ? '#059669' : '#ef4444') : '#9ca3af' }}>
                    {a.taux_commission ? formatMoney(commNette) : '—'}
                  </td>
                  <td style={{ padding: '12px 12px', fontSize: '13px', color: '#374151' }}>{formatDate(a.date_echeance)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

function VendeurAssocieSelect({ disponibles, onSelect }) {
  const sorted = [...disponibles].sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const filtered = sorted.filter(v => v.toLowerCase().includes(query.toLowerCase()));

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) { setOpen(false); setQuery(''); } };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  if (sorted.length === 0) return (
    <div style={{ fontSize: '13px', color: '#9ca3af', fontStyle: 'italic' }}>Tous les vendeurs sont déjà associés.</div>
  );

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <input
        value={query}
        onChange={e => { setQuery(e.target.value); if (!open) setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder="Rechercher un vendeur à associer…"
        style={{ padding: '9px 12px', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: '13px', outline: 'none', background: 'white', width: '100%', boxSizing: 'border-box' }}
      />
      {open && (
        <div style={{ position: 'absolute', top: 'calc(100% + 2px)', left: 0, right: 0, zIndex: 200, background: 'white', border: '1px solid #e5e7eb', borderRadius: '8px', boxShadow: '0 4px 16px rgba(0,0,0,0.12)', maxHeight: '200px', overflowY: 'auto' }}>
          {filtered.length === 0 ? (
            <div style={{ padding: '8px 12px', fontSize: '13px', color: '#9ca3af', fontStyle: 'italic' }}>Aucun résultat</div>
          ) : filtered.map(v => (
            <div key={v}
              onMouseDown={() => { onSelect(v); setQuery(''); setOpen(false); }}
              style={{ padding: '9px 12px', fontSize: '13px', color: '#1a2b4a', cursor: 'pointer', fontWeight: '400' }}
              onMouseEnter={e => e.currentTarget.style.background = '#f0fdf4'}
              onMouseLeave={e => e.currentTarget.style.background = 'white'}>
              {v}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function FicheProspect({ user }) {
  const { isMobile, isTablet } = useWindowSize();
  const gridCols = isMobile || isTablet ? '1fr' : '1fr 1fr';
  const { id } = useParams();
  const navigate = useNavigate();
  const [prospect, setProspect] = useState(null);
  const [edit, setEdit] = useState(false);
  const [editPresentation, setEditPresentation] = useState(false);
  const [editApporteur, setEditApporteur] = useState(false);
  const [form, setForm] = useState({});
  const [toast, setToast] = useState(null);
  const [vendeursCB, setVendeursCB] = useState([]);
  const [interactions, setInteractions] = useState([]);
  const [showInteractionForm, setShowInteractionForm] = useState(false);
  const [interactionForm, setInteractionForm] = useState({ type: 'Appel', contenu: '', date: new Date().toISOString().slice(0, 16) });
  const [editingInteraction, setEditingInteraction] = useState(null);
  const [editInteractionForm, setEditInteractionForm] = useState({ type: '', contenu: '', date: '' });
  const [showAgendaForm, setShowAgendaForm] = useState(false);
  const [agendaForm, setAgendaForm] = useState({ titre: '', date_debut: '', note: '', attribue_a_id: '' });
  // Utilisateurs proposés dans « Attribuée à ». La route ne renvoie que nom et
  // rôle — jamais les adresses email — et reste ouverte à tout compte connecté :
  // chacun peut confier une tâche à un collègue, pas seulement le patron.
  const [attribuables, setAttribuables] = useState([]);
  const [showAssurance, setShowAssurance] = useState(false);
  const assuranceRef = useRef(null);
  const [dossiers, setDossiers] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [newEmailForm, setNewEmailForm] = useState(null);
  const [newTelForm, setNewTelForm] = useState(null);
  const [conditionsParc, setConditionsParc] = useState([]);
  const [importingParc, setImportingParc] = useState(false);
  const parcFileRef = useRef(null);
  const [historiqueParc, setHistoriqueParc] = useState([]);

  const reloadDossiers = () => {
    axios.get(`${API}/prospects/${id}/dossiers`).then(res => setDossiers(res.data)).catch(() => {});
  };

  useEffect(() => {
    axios.get(`${API}/prospects/${id}`)
      .then(res => { setProspect(res.data); setForm(res.data); });
    axios.get(`${API}/vendeurs`).then(res => setVendeursCB(res.data.map(v => v.nom))).catch(() => {});
    axios.get(`${API}/interactions/${id}`).then(res => setInteractions(res.data)).catch(() => {});
    axios.get(`${API}/prospects/${id}/contacts`).then(res => setContacts(res.data)).catch(() => {});
    axios.get(`${API}/prospects/${id}/conditions-parc`).then(res => setConditionsParc(res.data)).catch(() => {});
    axios.get(`${API}/prospects/${id}/historique-parc`).then(res => setHistoriqueParc(res.data)).catch(() => {});
    reloadDossiers();
  }, [id]);

  useEffect(() => {
    if (showAssurance && assuranceRef.current) {
      setTimeout(() => assuranceRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
    }
  }, [showAssurance]);

  const formatPhone = (val) => {
    const digits = val.replace(/\D/g, '').slice(0, 10);
    return digits.match(/.{1,2}/g)?.join(' ') || '';
  };

  const sauvegarder = (onSuccess) => {
    if (!form.nom_societe?.trim()) {
      setToast({ message: 'Le nom de la société est obligatoire', type: 'error' });
      return;
    }
    axios.put(`${API}/prospects/${id}`, form)
      .then(res => {
        setProspect(res.data);
        setForm(res.data);
        setToast({ message: 'Modifié avec succès !', type: 'success' });
        if (onSuccess) onSuccess();
      });
  };

  const ajouterContact = (type, valeur, libelle) => {
    if (!valeur.trim()) return;
    axios.post(`${API}/prospects/${id}/contacts`, { type, valeur, libelle: libelle || null })
      .then(res => {
        setContacts(prev => [...prev, res.data]);
        if (type === 'email') setNewEmailForm(null);
        else setNewTelForm(null);
      })
      .catch(() => setToast({ message: 'Erreur lors de l\'ajout du contact', type: 'error' }));
  };

  const supprimerContact = (contactId) => {
    axios.delete(`${API}/prospects/${id}/contacts/${contactId}`)
      .then(() => setContacts(prev => prev.filter(c => c.id !== contactId)))
      .catch(() => setToast({ message: 'Erreur lors de la suppression', type: 'error' }));
  };

  const supprimer = () => {
    if (window.confirm(`Supprimer l'entreprise « ${prospect?.nom_societe || ''} » ?\n\nCela supprime l'entreprise elle-même. Pour retirer seulement une affaire chaude, annulez et utilisez sa corbeille (onglet Crédit ou Assurance, ou la liste des affaires chaudes du tableau de bord).`)) {
      axios.delete(`${API}/prospects/${id}`)
        .then(() => navigate('/prospects'))
        // Le serveur refuse (409) tant que l'entreprise a des éléments rattachés —
        // un contrat, un projet, un dossier — et dit lesquels. Sans ce `catch`, la
        // promesse échouait en silence : on cliquait, on confirmait, et rien ne se
        // passait, sans un mot. Le message du serveur s'affiche désormais tel quel.
        .catch(err => setToast({
          message: err.response?.data?.detail || 'La suppression a échoué.',
          type: 'error',
        }));
    }
  };

  const getTypeColor = (type) => (TYPE_CONFIG[type] || TYPE_CONFIG.prospect).color;
  const getTypeLabel = (type) => (TYPE_CONFIG[type] || TYPE_CONFIG.prospect).label;

  const toggleInteret = (interet) => {
    const current = parseList(form.interets_client);
    const updated = current.includes(interet)
      ? current.filter(i => i !== interet)
      : [...current, interet];
    setForm({ ...form, interets_client: serializeList(updated) });
  };

  const toggleVendeur = (vendeur) => {
    const current = parseList(form.vendeurs_associes);
    const updated = current.includes(vendeur)
      ? current.filter(v => v !== vendeur)
      : [...current, vendeur];
    setForm({ ...form, vendeurs_associes: serializeList(updated) });
  };

  const ajouterInteraction = () => {
    if (!interactionForm.contenu.trim()) return;
    axios.post(`${API}/interactions`, {
      prospect_id: parseInt(id),
      type: interactionForm.type,
      contenu: interactionForm.contenu,
      date: interactionForm.date ? new Date(interactionForm.date).toISOString() : null,
      utilisateur_nom: user?.nom || '',
    }).then(res => {
      setInteractions([res.data, ...interactions]);
      setInteractionForm({ type: 'Appel', contenu: '', date: new Date().toISOString().slice(0, 16) });
      setShowInteractionForm(false);
    });
  };

  const supprimerInteraction = (intId) => {
    axios.delete(`${API}/interactions/${intId}`)
      .then(() => setInteractions(interactions.filter(i => i.id !== intId)));
  };

  const ouvrirEditInteraction = (int) => {
    setEditingInteraction(int.id);
    setEditInteractionForm({
      type: int.type,
      contenu: int.contenu,
      date: new Date(int.date).toISOString().slice(0, 16),
    });
  };

  const sauvegarderInteraction = (intId) => {
    if (!editInteractionForm.contenu.trim()) return;
    axios.put(`${API}/interactions/${intId}`, {
      type: editInteractionForm.type,
      contenu: editInteractionForm.contenu,
      date: editInteractionForm.date ? new Date(editInteractionForm.date).toISOString() : null,
    }).then(res => {
      setInteractions(interactions.map(i => i.id === intId ? res.data : i));
      setEditingInteraction(null);
    });
  };

  const importerConditionsParc = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImportingParc(true);
    const fd = new FormData();
    fd.append('file', file);
    try {
      const importRes = await axios.post(
        `${API}/prospects/${id}/conditions-parc/import`,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      const { imported, debug } = importRes.data;
      const res = await axios.get(`${API}/prospects/${id}/conditions-parc`);
      setConditionsParc(res.data);
      if (imported === 0) {
        const sheets = debug?.sheets?.map(s => `"${s.name}" : ${s.mapped_columns?.length || 0} col. mappées`).join(', ') || '';
        setToast({ message: `0 véhicule importé. En-têtes non reconnus. ${sheets}`, type: 'error' });
      } else {
        setToast({ message: `${imported} véhicule(s) importé(s) avec succès`, type: 'success' });
      }
    } catch (err) {
      const detail = err?.response?.data?.detail || "Erreur lors de l'import Excel";
      setToast({ message: detail, type: 'error' });
    } finally {
      setImportingParc(false);
      e.target.value = '';
    }
  };

  const supprimerConditionParc = async (condId) => {
    if (!window.confirm('Supprimer cette ligne de parc ?')) return;
    await axios.delete(`${API}/prospects/${id}/conditions-parc/${condId}`);
    setConditionsParc(prev => prev.filter(c => c.id !== condId));
  };

  const creerTache = () => {
    if (!agendaForm.titre.trim() || !agendaForm.date_debut) return;
    axios.post(`${API}/agenda`, {
      titre: agendaForm.titre,
      type: 'Tâche',
      date_debut: new Date(agendaForm.date_debut).toISOString(),
      prospect_id: parseInt(id),
      note: agendaForm.note || null,
      attribue_a_id: agendaForm.attribue_a_id ? parseInt(agendaForm.attribue_a_id) : null,
    }).then(() => {
      setShowAgendaForm(false);
      setAgendaForm({ titre: '', date_debut: '', note: '', attribue_a_id: '' });
      setToast({ message: 'Tâche créée : elle apparaît dans le tableau de bord.', type: 'success' });
    });
  };

  const INTERACTION_STYLES = {
    'Appel':  { bg: '#dbeafe', text: '#1d4ed8', emoji: '📞' },
    'Email':  { bg: '#ede9fe', text: '#7c3aed', emoji: '✉️' },
    'RDV':    { bg: '#d1fae5', text: '#065f46', emoji: '📅' },
    'Note':   { bg: '#fef3c7', text: '#92400e', emoji: '📝' },
  };

  const inputStyle = champStyle;
  const btnSecondaire = { ...bouton('secondaire'), padding: '6px 14px' };

  if (!prospect) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',
                  height: '200px', color: C.texteFaible, fontSize: '13px' }}>
      Chargement…
    </div>
  );

  const currentType = prospect.type || 'prospect';
  const interets = parseList(prospect.interets_client);
  const vendeurs = parseList(prospect.vendeurs_associes);
  const anyEdit = edit || editPresentation || editApporteur;

  return (
    <div style={{ maxWidth: '980px' }}>
      <button onClick={() => navigate('/prospects')}
        style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.texteMoyen,
                 fontFamily: T.police, fontSize: '13px', marginBottom: E.lg, padding: 0,
                 display: 'flex', alignItems: 'center', gap: E.xs }}>
        ← Retour aux entreprises
      </button>

      {/* En-tête */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: isMobile ? 'flex-start' : 'center', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0', marginBottom: '24px' }}>
        <div>
          <h1 style={T.titre}>{prospect.nom_societe}</h1>
          <div style={{ display: 'flex', gap: E.sm, alignItems: 'center', marginTop: E.sm,
                        flexWrap: 'wrap' }}>
            <span style={{ background: getTypeColor(currentType) + '1a',
                           color: getTypeColor(currentType), padding: '3px 10px',
                           borderRadius: RAYON.rond, fontSize: '11.5px', fontWeight: 600 }}>
              {getTypeLabel(currentType)}
            </span>
            {prospect.siren && (
              <span style={{ fontSize: '12px', color: C.texteFaible }}>
                SIREN {prospect.siren}
              </span>
            )}
          </div>
        </div>
        {!anyEdit && (
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <button onClick={() => setEdit(true)} style={bouton('principal')}>
              Modifier
            </button>
            <button onClick={() => navigate(`/dossier?prospect_id=${id}`)} style={bouton('secondaire')}>
              Créer un dossier
            </button>
            <button onClick={() => {
                setAgendaForm({ titre: '', date_debut: '', note: '',
                                attribue_a_id: user?.id ? String(user.id) : '' });
                axios.get(`${API}/utilisateurs/attribuables`)
                  .then(res => setAttribuables(res.data.filter(u => u.actif)))
                  .catch(() => setAttribuables([]));
                setShowAgendaForm(true);
              }}
              style={bouton('secondaire')}>
              Tâche
            </button>
            <button onClick={() => setShowAssurance(true)}
              style={showAssurance ? bouton('principal') : bouton('secondaire')}>
              Assurance
            </button>
            {/* Ce bouton supprime l'ENTREPRISE. Libellé « Supprimer » tout court :
                on le prenait pour la suppression de l'affaire chaude, et le
                serveur le refusait (409) tant qu'un contrat y était rattaché. */}
            {user?.role === 'admin' && (
              <button onClick={supprimer} style={bouton('danger')}
                      title="Supprime l'entreprise. Pour retirer seulement une affaire, utilisez sa corbeille dans l'onglet Crédit ou Assurance.">
                Supprimer l'entreprise
              </button>
            )}
          </div>
        )}
      </div>

      {/* Informations */}
      <div style={carteSection}>
        {edit ? (
          <>
            <h2 style={titreSection}>Modifier les informations</h2>
            <div style={{ display: 'grid', gridTemplateColumns: gridCols, gap: '16px' }}>
              {[
                { key: 'nom_societe', label: 'Nom société' },
                { key: 'siren', label: 'SIREN' },
                { key: 'nom_dirigeant', label: 'Dirigeant' },
                { key: 'adresse', label: 'Adresse' },
                { key: 'canal', label: 'Canal' },
              ].map(({ key, label }) => (
                <div key={key}>
                  <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>{label}</label>
                  <input value={form[key] || ''} onChange={e => setForm({ ...form, [key]: e.target.value })} style={inputStyle} />
                </div>
              ))}
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>Type</label>
                <select value={form.type || 'prospect'} onChange={e => setForm({ ...form, type: e.target.value })} style={inputStyle}>
                  <option value="prospect">Prospect</option>
                  <option value="client">Client</option>
                  <option value="apporteur">Apporteur</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => sauvegarder(() => setEdit(false))}
                style={{ background: '#1a2b4a', color: 'white', padding: '10px 24px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>Sauvegarder
              </button>
              <button onClick={() => { setEdit(false); setForm(prospect); }} style={{ ...inputStyle, width: 'auto', color: '#6b7280', cursor: 'pointer' }}>
                Annuler
              </button>
            </div>
          </>
        ) : (
          <>
            <h2 style={titreSection}>Informations</h2>
            <div style={{ display: 'grid', gridTemplateColumns: gridCols, gap: '20px' }}>
              {[
                { label: 'SIREN', value: prospect.siren },
                { label: 'Dirigeant', value: prospect.nom_dirigeant },
                { label: 'Canal', value: prospect.canal },
                { label: 'Adresse', value: prospect.adresse },
              ].map(({ label, value }) => (
                <div key={label}>
                  <div style={{ fontSize: '12px', color: '#9ca3af', fontWeight: '500', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{label}</div>
                  <div style={{ fontSize: '14px', color: value ? '#1a2b4a' : '#d1d5db', fontWeight: value ? '500' : '400' }}>{value || '—'}</div>
                </div>
              ))}
              <MiniCarte adresse={prospect.adresse} />
            </div>
          </>
        )}
      </div>

      {/* Coordonnées (emails + téléphones) */}
      <div style={carteSection}>
        <h2 style={titreSection}>Coordonnées</h2>
        <div style={{ display: 'grid', gridTemplateColumns: gridCols, gap: '24px' }}>

          {/* Emails */}
          <div>
            <div style={{ fontSize: '12px', color: '#9ca3af', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '10px' }}>Emails</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {contacts.filter(c => c.type === 'email').map(c => (
                <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                  {c.libelle && (
                    <span style={{ background: '#eff6ff', color: '#1d4ed8', padding: '2px 8px', borderRadius: '99px', fontSize: '11px', fontWeight: '600', whiteSpace: 'nowrap', flexShrink: 0 }}>
                      {c.libelle}
                    </span>
                  )}
                  <a href={`mailto:${c.valeur}`} style={{ fontSize: '13px', color: '#1a2b4a', fontWeight: '500', textDecoration: 'none', flex: 1 }}
                    onMouseEnter={e => e.target.style.textDecoration = 'underline'}
                    onMouseLeave={e => e.target.style.textDecoration = 'none'}>
                    ✉️ {c.valeur}
                  </a>
                  <button title="Supprimer" onClick={() => supprimerContact(c.id)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#d1d5db', fontSize: '14px', padding: 0, flexShrink: 0 }}
                    onMouseEnter={e => e.target.style.color = '#ef4444'}
                    onMouseLeave={e => e.target.style.color = '#d1d5db'}><IconeCorbeille taille={15} />
                  </button>
                </div>
              ))}
              {contacts.filter(c => c.type === 'email').length === 0 && !newEmailForm && (
                <div style={{ fontSize: '13px', color: '#d1d5db' }}>Aucun email renseigné</div>
              )}
            </div>
            {newEmailForm ? (
              <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <input placeholder="Libellé (ex : Direction)" value={newEmailForm.libelle}
                  onChange={e => setNewEmailForm(f => ({ ...f, libelle: e.target.value }))}
                  style={{ ...inputStyle, fontSize: '13px' }} />
                <input placeholder="adresse@email.com" value={newEmailForm.valeur}
                  onChange={e => setNewEmailForm(f => ({ ...f, valeur: e.target.value }))}
                  style={{ ...inputStyle, fontSize: '13px' }} />
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={() => ajouterContact('email', newEmailForm.valeur, newEmailForm.libelle)}
                    style={{ background: '#1a2b4a', color: 'white', padding: '7px 16px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
                    Ajouter
                  </button>
                  <button onClick={() => setNewEmailForm(null)} style={{ ...btnSecondaire, padding: '7px 12px' }}>Annuler</button>
                </div>
              </div>
            ) : (
              <button onClick={() => setNewEmailForm({ valeur: '', libelle: '' })}
                style={{ marginTop: '10px', background: 'none', border: '1px dashed #d1d5db', color: '#6b7280', padding: '7px 14px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', width: '100%' }}>
                + Ajouter un email
              </button>
            )}
          </div>

          {/* Téléphones */}
          <div>
            <div style={{ fontSize: '12px', color: '#9ca3af', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '10px' }}>Téléphones</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {contacts.filter(c => c.type === 'telephone').map(c => (
                <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                  {c.libelle && (
                    <span style={{ background: '#f0fdf4', color: '#15803d', padding: '2px 8px', borderRadius: '99px', fontSize: '11px', fontWeight: '600', whiteSpace: 'nowrap', flexShrink: 0 }}>
                      {c.libelle}
                    </span>
                  )}
                  <div style={{ flex: 1, display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap' }}>
                    <a href={`tel:${c.valeur.replace(/\s/g, '')}`} style={{ fontSize: '13px', color: '#1a2b4a', fontWeight: '500', textDecoration: 'none' }}
                      onMouseEnter={e => e.target.style.textDecoration = 'underline'}
                      onMouseLeave={e => e.target.style.textDecoration = 'none'}>{c.valeur}
                    </a>
                    <a href={`https://wa.me/33${c.valeur.replace(/^0/, '').replace(/\s/g, '')}`} target="_blank" rel="noopener noreferrer"
                      style={{ fontSize: '11px', background: '#d1fae5', color: '#065f46', padding: '2px 8px', borderRadius: '99px', textDecoration: 'none', fontWeight: '600', border: '1px solid #6ee7b7', whiteSpace: 'nowrap' }}>WA
                    </a>
                  </div>
                  <button title="Supprimer" onClick={() => supprimerContact(c.id)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#d1d5db', fontSize: '14px', padding: 0, flexShrink: 0 }}
                    onMouseEnter={e => e.target.style.color = '#ef4444'}
                    onMouseLeave={e => e.target.style.color = '#d1d5db'}><IconeCorbeille taille={15} />
                  </button>
                </div>
              ))}
              {contacts.filter(c => c.type === 'telephone').length === 0 && !newTelForm && (
                <div style={{ fontSize: '13px', color: '#d1d5db' }}>Aucun téléphone renseigné</div>
              )}
            </div>
            {newTelForm ? (
              <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <input placeholder="Libellé (ex : Commercial)" value={newTelForm.libelle}
                  onChange={e => setNewTelForm(f => ({ ...f, libelle: e.target.value }))}
                  style={{ ...inputStyle, fontSize: '13px' }} />
                <input placeholder="06 12 34 56 78" value={newTelForm.valeur}
                  onChange={e => setNewTelForm(f => ({ ...f, valeur: formatPhone(e.target.value) }))}
                  style={{ ...inputStyle, fontSize: '13px' }} />
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={() => ajouterContact('telephone', newTelForm.valeur, newTelForm.libelle)}
                    style={{ background: '#1a2b4a', color: 'white', padding: '7px 16px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
                    Ajouter
                  </button>
                  <button onClick={() => setNewTelForm(null)} style={{ ...btnSecondaire, padding: '7px 12px' }}>Annuler</button>
                </div>
              </div>
            ) : (
              <button onClick={() => setNewTelForm({ valeur: '', libelle: '' })}
                style={{ marginTop: '10px', background: 'none', border: '1px dashed #d1d5db', color: '#6b7280', padding: '7px 14px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', width: '100%' }}>
                + Ajouter un téléphone
              </button>
            )}
          </div>

        </div>
      </div>

      {/* Présentation de l'entreprise */}
      <div style={carteSection}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ color: '#1a2b4a', fontSize: '16px', fontWeight: '600', margin: 0 }}>Présentation de l'entreprise</h2>
          {!editPresentation && !anyEdit && (
            <button onClick={() => setEditPresentation(true)} style={btnSecondaire}>Modifier</button>
          )}
        </div>
        {editPresentation ? (
          <>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                Présentation générale
              </label>
              <textarea
                value={form.presentation || ''}
                onChange={e => setForm({ ...form, presentation: e.target.value })}
                rows={4}
                placeholder="Décrivez l'entreprise, son activité, ses clients..."
                style={{ ...inputStyle, resize: 'vertical', fontFamily: 'inherit', lineHeight: '1.5' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '10px', fontSize: '12px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                Intérêts client
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {INTERETS_CLIENT.map(interet => {
                  const checked = parseList(form.interets_client).includes(interet);
                  return (
                    <label key={interet} style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', background: checked ? '#eff6ff' : '#f8fafc', border: `1px solid ${checked ? '#bfdbfe' : '#e5e7eb'}`, borderRadius: '6px', padding: '6px 12px', fontSize: '13px', color: checked ? '#1d4ed8' : '#374151', fontWeight: checked ? '600' : '400', userSelect: 'none' }}>
                      <input type="checkbox" checked={checked} onChange={() => toggleInteret(interet)} style={{ margin: 0 }} />
                      {interet}
                    </label>
                  );
                })}
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => sauvegarder(() => setEditPresentation(false))}
                style={{ background: '#1a2b4a', color: 'white', padding: '10px 24px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>Sauvegarder
              </button>
              <button onClick={() => { setEditPresentation(false); setForm(prospect); }} style={btnSecondaire}>
                Annuler
              </button>
            </div>
          </>
        ) : (
          <div>
            {prospect.presentation ? (
              <p style={{ fontSize: '14px', color: '#374151', lineHeight: '1.7', margin: '0 0 14px', whiteSpace: 'pre-wrap' }}>{prospect.presentation}</p>
            ) : (
              <p style={{ fontSize: '14px', color: '#d1d5db', margin: '0 0 12px' }}>Aucune présentation. Décrivez l'activité de l'entreprise pour la retrouver plus vite.</p>
            )}
            {interets.length > 0 && (
              <div>
                <div style={{ fontSize: '12px', color: '#9ca3af', fontWeight: '500', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Intérêts</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                  {interets.map(i => (
                    <span key={i} style={{ background: '#eff6ff', color: '#1d4ed8', padding: '3px 10px', borderRadius: '99px', fontSize: '12px', fontWeight: '600', border: '1px solid #bfdbfe' }}>{i}</span>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Vendeurs associés — apporteur uniquement */}
      {!showAssurance && currentType === 'apporteur' && (
        <div style={carteSection}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <h2 style={{ color: '#1a2b4a', fontSize: '16px', fontWeight: '600', margin: 0 }}>Vendeurs associés</h2>
            {!editApporteur && !anyEdit && (
              <button onClick={() => setEditApporteur(true)} style={btnSecondaire}>Modifier</button>
            )}
          </div>
          {editApporteur ? (
            <>
              {/* Tags des vendeurs sélectionnés */}
              {parseList(form.vendeurs_associes).length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                  {parseList(form.vendeurs_associes).map(v => (
                    <span key={v} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#f0fdf4', color: '#15803d', border: '1px solid #86efac', borderRadius: '99px', padding: '4px 12px', fontSize: '13px', fontWeight: '600' }}>
                      {v}
                      <button onClick={() => toggleVendeur(v)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#15803d', fontSize: '12px', padding: 0, lineHeight: 1, display: 'flex', alignItems: 'center' }}>
                        ✕
                      </button>
                    </span>
                  ))}
                </div>
              )}
              {/* Dropdown de recherche */}
              <div style={{ marginBottom: '20px' }}>
                <VendeurAssocieSelect
                  disponibles={vendeursCB.filter(v => !parseList(form.vendeurs_associes).includes(v))}
                  onSelect={(nom) => toggleVendeur(nom)}
                />
              </div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button onClick={() => sauvegarder(() => setEditApporteur(false))}
                  style={{ background: '#1a2b4a', color: 'white', padding: '10px 24px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>Sauvegarder
                </button>
                <button onClick={() => { setEditApporteur(false); setForm(prospect); }} style={btnSecondaire}>
                  Annuler
                </button>
              </div>
            </>
          ) : (
            <div>
              {vendeurs.length > 0 ? (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {vendeurs.map(v => (
                    <span key={v} style={{ background: '#f0fdf4', color: '#15803d', padding: '4px 12px', borderRadius: '99px', fontSize: '13px', fontWeight: '600', border: '1px solid #86efac' }}>{v}</span>
                  ))}
                </div>
              ) : (
                <p style={{ fontSize: '13px', color: '#9ca3af', margin: 0 }}>Aucun vendeur associé. Cliquez sur Modifier pour en sélectionner.</p>
              )}
            </div>
          )}
        </div>
      )}

      {/* Affaires amenées — apporteur uniquement */}
      {!showAssurance && currentType === 'apporteur' && <AffairesAmenes apporteurId={parseInt(id)} />}

      {/* Projets / Besoins */}
      {!showAssurance && <Projets prospectId={parseInt(id)} nomSociete={prospect.nom_societe} user={user} />}

      {/* Conditions de parc */}
      {!showAssurance && (
        <div style={carteSection}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <h2 style={{ color: '#1a2b4a', fontSize: '16px', fontWeight: '600', margin: 0 }}>Conditions de parc
              <span style={{ color: '#9ca3af', fontSize: '13px', fontWeight: '400', marginLeft: '8px' }}>({conditionsParc.length} véhicule{conditionsParc.length !== 1 ? 's' : ''})</span>
            </h2>
            {user?.role === 'admin' && (
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                {conditionsParc.length > 0 && (
                  <button
                    onClick={() => { if (window.confirm('Vider tout le parc et réimporter ?')) parcFileRef.current?.click(); }}
                    style={{ background: '#f3f4f6', color: '#6b7280', padding: '7px 14px', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>Réimporter
                  </button>
                )}
                <button
                  onClick={() => parcFileRef.current?.click()}
                  disabled={importingParc}
                  style={{ background: '#1a2b4a', color: 'white', padding: '7px 14px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '500', opacity: importingParc ? 0.6 : 1 }}>
                  {importingParc ? '⏳ Import…' : '📥 Importer Excel'}
                </button>
                <input ref={parcFileRef} type="file" accept=".xlsx,.xls" style={{ display: 'none' }} onChange={importerConditionsParc} />
              </div>
            )}
          </div>

          {conditionsParc.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '30px', color: '#9ca3af', fontSize: '14px' }}>
              Aucune condition de parc. {user?.role === 'admin' ? 'Importez un fichier Excel pour commencer.' : ''}
            </div>
          ) : (
            <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '500px' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', minWidth: '1600px' }}>
                <thead>
                  <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e5e7eb', position: 'sticky', top: 0, zIndex: 1 }}>
                    {[
                      'Immatriculation', 'Marque / Modèle', 'Genre', 'Date 1ère MEC',
                      'March. dangereuses', 'PTAC / PTRA', 'Valeur déclarée (€)', 'Énergie', 'Usage', 'Zone',
                      'RC Défense/Recours', 'RC Fonctionnement', 'Faute inexcusable',
                      'Dommage tous accidents', 'Franchise DTA (€)',
                      'Vol', 'Franchise Vol (€)', 'Incendie', 'Franchise Incendie (€)',
                      'Catastrophes naturelles', 'Remorquage/Levage', 'Limitation (€)',
                      'Bris de glace', 'Franchise BDG (€)',
                      'Immobilisation', 'Sécurité conducteur', 'Perte financière',
                      'Assistance Chauffeur PL', 'Assistance Ch.+Véhicule', 'Véhicule remplacement',
                      "Date d'entrée", 'Date de sortie', 'Prime HT (€)', 'Prime TTC (€)', '',
                    ].map((h, i) => (
                      <th key={i} style={{ padding: '8px 10px', textAlign: 'left', fontSize: '10px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.03em', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const boolCell = (v) => v === true ? '✅' : v === false ? '❌' : '—';
                    const strCell  = (v) => v || '—';
                    const dtCell   = (v) => v ? new Date(v + 'T00:00:00').toLocaleDateString('fr-FR') : '—';
                    return conditionsParc.map((c, idx) => (
                      <tr key={`parc-row-${c.id}`} style={{ borderBottom: '1px solid #f3f4f6', background: idx % 2 === 0 ? 'white' : '#fafafa' }}>
                        <td style={{ padding: '8px 10px', fontWeight: '600', color: '#1a2b4a', whiteSpace: 'nowrap', fontFamily: 'monospace' }}>{strCell(c.immatriculation)}</td>
                        <td style={{ padding: '8px 10px', whiteSpace: 'nowrap' }}>{strCell(c.marque_modele)}</td>
                        <td style={{ padding: '8px 10px', whiteSpace: 'nowrap' }}>{strCell(c.genre)}</td>
                        <td style={{ padding: '8px 10px', whiteSpace: 'nowrap' }}>{dtCell(c.date_mise_en_circulation)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.marchandises_dangereuses)}</td>
                        <td style={{ padding: '8px 10px' }}>{strCell(c.ptac_ptra)}</td>
                        <td style={{ padding: '8px 10px' }}>{strCell(c.valeur_declaree)}</td>
                        <td style={{ padding: '8px 10px' }}>{strCell(c.energie)}</td>
                        <td style={{ padding: '8px 10px' }}>{strCell(c.usage)}</td>
                        <td style={{ padding: '8px 10px' }}>{strCell(c.zone)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.rc_defense_recours)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.rc_fonctionnement)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.faute_inexcusable)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.dommage_tous_accidents)}</td>
                        <td style={{ padding: '8px 10px', whiteSpace: 'nowrap', color: '#6b7280' }}>{strCell(c.dommage_franchise)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.vol)}</td>
                        <td style={{ padding: '8px 10px', whiteSpace: 'nowrap', color: '#6b7280' }}>{strCell(c.vol_franchise)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.incendie)}</td>
                        <td style={{ padding: '8px 10px', whiteSpace: 'nowrap', color: '#6b7280' }}>{strCell(c.incendie_franchise)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.catastrophes_naturelles)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.remorquage_levage)}</td>
                        <td style={{ padding: '8px 10px', whiteSpace: 'nowrap', color: '#6b7280' }}>{strCell(c.remorquage_limitation)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.bris_de_glace)}</td>
                        <td style={{ padding: '8px 10px', whiteSpace: 'nowrap', color: '#6b7280' }}>{strCell(c.bris_franchise)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.immobilisation)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.securite_conducteur)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.perte_financiere)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.assistance_chauffeur_pl)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.assistance_chauffeur_et_vehicule)}</td>
                        <td style={{ padding: '8px 10px', textAlign: 'center' }}>{boolCell(c.vehicule_remplacement)}</td>
                        <td style={{ padding: '8px 10px', whiteSpace: 'nowrap' }}>{dtCell(c.date_entree)}</td>
                        <td style={{ padding: '8px 10px', whiteSpace: 'nowrap' }}>{dtCell(c.date_sortie)}</td>
                        <td style={{ padding: '8px 10px', whiteSpace: 'nowrap', fontWeight: '500' }}>{strCell(c.prime_ht)}</td>
                        <td style={{ padding: '8px 10px', whiteSpace: 'nowrap', fontWeight: '600', color: '#1a2b4a' }}>{strCell(c.prime_ttc)}</td>
                        <td style={{ padding: '8px 10px', width: '32px' }}>
                          {user?.role === 'admin' && (
                            <button title="Supprimer" onClick={() => supprimerConditionParc(c.id)}
                              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '14px', padding: '2px 4px' }}><IconeCorbeille taille={15} />
                            </button>
                          )}
                        </td>
                      </tr>
                    ));
                  })()}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Historique des actions client parc */}
      {!showAssurance && historiqueParc.length > 0 && (
        <div style={carteSection}>
          <h2 style={titreSection}>Historique des actions client
            <span style={{ color: '#9ca3af', fontSize: '13px', fontWeight: '400', marginLeft: '8px' }}>({historiqueParc.length} action{historiqueParc.length !== 1 ? 's' : ''})</span>
          </h2>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '500px' }}>
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e5e7eb' }}>
                  {['Date', 'Action', 'Plaque', 'Valeur', 'Auteur', 'PJ'].map(h => (
                    <th key={h} style={{ padding: '9px 12px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {historiqueParc.map(h => (
                  <tr key={h.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '10px 12px', fontSize: '13px', color: '#6b7280', whiteSpace: 'nowrap' }}>
                      {h.date_action ? new Date(h.date_action).toLocaleDateString('fr-FR') : '—'}
                    </td>
                    <td style={{ padding: '10px 12px' }}>
                      <span style={{
                        background: h.type_action === 'entree' ? '#d1fae5' : '#fee2e2',
                        color: h.type_action === 'entree' ? '#065f46' : '#991b1b',
                        border: `1px solid ${h.type_action === 'entree' ? '#6ee7b7' : '#fca5a5'}`,
                        padding: '2px 9px', borderRadius: '99px', fontSize: '11px', fontWeight: '600',
                      }}>
                        {h.type_action === 'entree' ? '🟢 Entrée' : '🔴 Sortie'}
                      </span>
                    </td>
                    <td style={{ padding: '10px 12px', fontSize: '13px', fontWeight: '600', color: '#1a2b4a', fontFamily: 'monospace' }}>{h.immatriculation}</td>
                    <td style={{ padding: '10px 12px', fontSize: '13px', color: '#374151' }}>
                      {h.valeur != null ? `${Number(h.valeur).toLocaleString('fr-FR')} €` : '—'}
                    </td>
                    <td style={{ padding: '10px 12px', fontSize: '12px', color: '#6b7280' }}>{h.auteur || 'client'}</td>
                    <td style={{ padding: '10px 12px' }}>
                      {h.piece_jointe ? (
                        <a href={urlFichier(`${API}/uploads/parc-historique/${h.piece_jointe}`)} target="_blank" rel="noopener noreferrer"
                          style={{ background: '#f0f7ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: '4px', padding: '3px 8px', fontSize: '11px', fontWeight: '500', textDecoration: 'none' }}>{h.nom_fichier || 'PJ'}
                        </a>
                      ) : (
                        // Un tiret gris ne se remarquait pas : c'est ainsi que
                        // trois mois de pièces perdues sont passés inaperçus.
                        // Le justificatif se dépose depuis l'extranet du client.
                        <span title="Le client doit la déposer depuis son espace"
                          style={{ background: '#fff7ed', color: '#9a3412', border: '1px solid #fed7aa',
                                   borderRadius: '4px', padding: '3px 8px', fontSize: '11px', fontWeight: '600' }}>
                          Manquante
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Section Assurance en mode focus */}
      {showAssurance && (
        <div ref={assuranceRef}>
          <div style={{ marginBottom: '16px' }}>
            <button onClick={() => setShowAssurance(false)}
              style={{ background: 'white', color: '#1a2b4a', padding: '8px 16px', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '6px' }}>
              ← Vue complète
            </button>
          </div>
          <Assurance prospectId={parseInt(id)} user={user} />
        </div>
      )}

      {/* Dossiers de financement */}
      {!showAssurance && <div style={carteSection}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ color: '#1a2b4a', fontSize: '16px', fontWeight: '600', margin: 0 }}>Dossiers de financement
            <span style={{ color: '#9ca3af', fontSize: '13px', fontWeight: '400', marginLeft: '8px' }}>({dossiers.length})</span>
          </h2>
          <button onClick={() => navigate(`/dossier?prospect_id=${id}`)}
            style={{ background: '#1a2b4a', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
            + Nouveau dossier
          </button>
        </div>
        {dossiers.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '30px', color: '#9ca3af', fontSize: '14px' }}>
            Aucun dossier de financement créé
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e5e7eb' }}>
                {['Numéro', 'Date', 'Montant', 'Type', 'Statut'].map(h => (
                  <th key={h} style={{ padding: '10px 12px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dossiers.map(d => {
                const DOSSIER_STATUTS = {
                  'En cours': { bg: '#dbeafe', text: '#1e40af' },
                  'Accepté': { bg: '#d1fae5', text: '#065f46' },
                  'Refusé': { bg: '#fee2e2', text: '#991b1b' },
                  'Annulé': { bg: '#f3f4f6', text: '#6b7280' },
                };
                const s = DOSSIER_STATUTS[d.statut] || { bg: '#f3f4f6', text: '#6b7280' };
                const TYPE_LABELS = { credit_bail: 'Crédit-bail', location_financiere: 'Location financière', enveloppe: 'Enveloppe', achat: 'Achat' };
                return (
                  <tr key={d.id}
                    onClick={() => navigate(`/dossier?dossier_id=${d.id}`)}
                    style={{ borderBottom: '1px solid #f3f4f6', cursor: 'pointer' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                    <td style={{ padding: '12px 12px', fontSize: '13px', fontWeight: '700', color: '#1a2b4a' }}>{d.numero}</td>
                    <td style={{ padding: '12px 12px', fontSize: '13px', color: '#374151' }}>{new Date(d.date_creation).toLocaleDateString('fr-FR')}</td>
                    <td style={{ padding: '12px 12px', fontSize: '13px', fontWeight: '600', color: '#1a2b4a' }}>
                      {d.montant_total ? Number(d.montant_total).toLocaleString('fr-FR') + ' €' : '—'}
                    </td>
                    <td style={{ padding: '12px 12px', fontSize: '13px', color: '#374151' }}>
                      {TYPE_LABELS[d.type_financement] || d.type_financement || '—'}
                    </td>
                    <td style={{ padding: '12px 12px' }}>
                      <span style={{ background: s.bg, color: s.text, padding: '3px 9px', borderRadius: '99px', fontSize: '11px', fontWeight: '600' }}>
                        {d.statut}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>}

      {!showAssurance && !anyEdit && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
          <button onClick={() => setEdit(true)}
            style={{ background: '#1a2b4a', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>Modifier
          </button>
        </div>
      )}

      {/* Historique des interactions */}
      {!showAssurance && <div style={carteSection}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ color: '#1a2b4a', fontSize: '16px', fontWeight: '600', margin: 0 }}>Historique des interactions
            <span style={{ color: '#9ca3af', fontSize: '13px', fontWeight: '400', marginLeft: '8px' }}>({interactions.length})</span>
          </h2>
          {!showInteractionForm && (
            <button onClick={() => setShowInteractionForm(true)}
              style={{ background: '#1a2b4a', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
              + Ajouter une interaction
            </button>
          )}
        </div>

        {showInteractionForm && (
          <div style={{ background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '20px', marginBottom: '20px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>Type</label>
                <select value={interactionForm.type} onChange={e => setInteractionForm({ ...interactionForm, type: e.target.value })} style={inputStyle}>
                  {['Appel', 'Email', 'RDV', 'Note'].map(t => <option key={t}>{t}</option>)}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>Date</label>
                <input type="datetime-local" value={interactionForm.date}
                  onChange={e => setInteractionForm({ ...interactionForm, date: e.target.value })} style={inputStyle} />
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>Contenu</label>
                <textarea value={interactionForm.contenu}
                  onChange={e => setInteractionForm({ ...interactionForm, contenu: e.target.value })}
                  rows={3} placeholder="Décrivez l'interaction..."
                  style={{ ...inputStyle, resize: 'vertical' }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={ajouterInteraction}
                style={{ background: '#1a2b4a', color: 'white', padding: '10px 24px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>
                Enregistrer
              </button>
              <button onClick={() => setShowInteractionForm(false)} style={btnSecondaire}>Annuler</button>
            </div>
          </div>
        )}

        {interactions.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '30px', color: '#9ca3af', fontSize: '14px' }}>
            Aucune interaction enregistrée
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {interactions.map(int => {
              const style = INTERACTION_STYLES[int.type] || INTERACTION_STYLES['Note'];
              if (editingInteraction === int.id) {
                return (
                  <div key={int.id} style={{ background: '#f8fafc', border: '1px solid #bfdbfe', borderRadius: '8px', padding: '14px 16px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                      <div>
                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>Type</label>
                        <select value={editInteractionForm.type}
                          onChange={e => setEditInteractionForm({ ...editInteractionForm, type: e.target.value })}
                          style={inputStyle}>
                          {['Appel', 'Email', 'RDV', 'Note'].map(t => <option key={t}>{t}</option>)}
                        </select>
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>Date</label>
                        <input type="datetime-local" value={editInteractionForm.date}
                          onChange={e => setEditInteractionForm({ ...editInteractionForm, date: e.target.value })}
                          style={inputStyle} />
                      </div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>Contenu</label>
                        <textarea value={editInteractionForm.contenu}
                          onChange={e => setEditInteractionForm({ ...editInteractionForm, contenu: e.target.value })}
                          rows={3} style={{ ...inputStyle, resize: 'vertical' }} />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button onClick={() => sauvegarderInteraction(int.id)}
                        style={{ background: '#1a2b4a', color: 'white', padding: '8px 20px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>Sauvegarder
                      </button>
                      <button onClick={() => setEditingInteraction(null)} style={btnSecondaire}>Annuler</button>
                    </div>
                  </div>
                );
              }
              return (
                <div key={int.id} style={{ display: 'flex', gap: '14px', padding: '14px 16px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e5e7eb', alignItems: 'flex-start' }}>
                  <span style={{ background: style.bg, color: style.text, padding: '4px 10px', borderRadius: '99px', fontSize: '12px', fontWeight: '600', whiteSpace: 'nowrap', border: `1px solid ${style.bg}`, flexShrink: 0 }}>
                    {style.emoji} {int.type}
                  </span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ margin: '0 0 4px', fontSize: '14px', color: '#1a2b4a', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>{int.contenu}</p>
                    <div style={{ display: 'flex', gap: '12px', fontSize: '12px', color: '#9ca3af' }}>
                      <span>{new Date(int.date).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                      {int.utilisateur_nom && <span>— {int.utilisateur_nom}</span>}
                    </div>
                  </div>
                  <button title="Modifier" onClick={() => ouvrirEditInteraction(int)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280', fontSize: '15px', flexShrink: 0, padding: '2px 4px' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#1a2b4a'}
                    onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}><IconeCrayon taille={15} />
                  </button>
                  {user?.role === 'admin' && (
                    <button title="Supprimer" onClick={() => supprimerInteraction(int.id)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '16px', flexShrink: 0 }}><IconeCorbeille taille={15} />
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>}

      {/* Modal Agenda */}
      {showAgendaForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '28px', width: '420px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
            <h2 style={titreSection}>Nouvelle tâche</h2>
            <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '16px' }}>Entreprise : <strong style={{ color: '#1a2b4a' }}>{prospect?.nom_societe}</strong></div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {/* Attribuée à : une tâche sans destinataire n'est l'affaire de
                  personne. Par défaut, celui qui la crée — se donner une tâche
                  à soi-même est le cas le plus fréquent. */}
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#6b7280', marginBottom: '4px' }}>Attribuée à *</label>
                <select value={agendaForm.attribue_a_id}
                  onChange={e => setAgendaForm({ ...agendaForm, attribue_a_id: e.target.value })}
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: '14px', outline: 'none', boxSizing: 'border-box', background: 'white' }}>
                  <option value="">— Choisir une personne —</option>
                  {attribuables.map(u => (
                    <option key={u.id} value={u.id}>{u.nom}{u.role === 'admin' ? ' (admin)' : ''}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#6b7280', marginBottom: '4px' }}>Titre *</label>
                <input value={agendaForm.titre} onChange={e => setAgendaForm({ ...agendaForm, titre: e.target.value })}
                  placeholder="Ex : Résiliation ancienne flotte"
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#6b7280', marginBottom: '4px' }}>Date et heure *</label>
                <input type="datetime-local" value={agendaForm.date_debut} onChange={e => setAgendaForm({ ...agendaForm, date_debut: e.target.value })}
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#6b7280', marginBottom: '4px' }}>Note</label>
                <textarea value={agendaForm.note} onChange={e => setAgendaForm({ ...agendaForm, note: e.target.value })}
                  rows={2} placeholder="Note optionnelle..."
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: '14px', outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit' }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={creerTache}
                disabled={!agendaForm.titre.trim() || !agendaForm.date_debut || !agendaForm.attribue_a_id}
                style={{ flex: 1, background: '#3b82f6', color: 'white', padding: '11px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>
                Créer la tâche
              </button>
              <button onClick={() => setShowAgendaForm(false)}
                style={{ padding: '11px 20px', background: 'white', color: '#6b7280', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' }}>
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}

      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
}

export default FicheProspect;
